<template>
  <div>
    <v-container fluid v-if="!EditdialogUser && !AddVector">
      <v-card class="card2" style="margin-top: 1rem">
        <v-card-text>
          <v-row align="center">
            <v-col cols="12" md="5" lg="5">
              <h1 style="font-weight: 500; font-size: 28px;" class="ml-4">{{ $t("_DocumentList") }}</h1>
            </v-col>
            <v-col cols="12" sm="12" md="7" lg="7" class="d-flex flex-wrap justify-end gap-2">
              <v-row no-gutters class="d-flex justify-end" style="gap: 20px;">
                  <div class="custom-search-input-wrapper">
                    <div class="custom-search-input-container">
                      <v-icon class="custom-search-input-icon">mdi-magnify</v-icon>
                      <input id="documentname-field-uploadsoundtodocument" type="text" :placeholder="$t('documentName')"
                        :aria-label="$t('documentName')"
                        class="custom-search-input" v-model="searchVectorDBName" maxlength="1000"
                        @keydown.enter="Search" />
                      <v-icon class="clear-icon" :style="searchVectorDBName ? '' : 'color: transparent !important;'"
                        @click="searchVectorDBName = ''">
                        mdi-close-circle
                      </v-icon>
                    </div>
                  </div>
                  <v-btn id="button-create-uploadCSV" color="primary" class="control-btn create-btn" variant="elevated"
                  size="large" prepend-icon="mdi-plus" rounded="xl" @click="Add()">
                  <span class="btn-text">{{ $t("add") }}</span>
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-data-table-server v-model:options="options" :items-per-page="itemsPerPage" :items-length="searchTotalTable"
          :items="dataTable" :headers="headers" :loading="loadingTable" class="pa-5">
          <template v-slot:item="{ item }">
            <tr>
              <td style="text-align: center">{{ item.number }}</td>
              <td>{{ item.vectorDBName }}</td>
              <td>
                <v-menu location="bottom">
                  <template v-slot:activator="{ props }">
                    <v-btn id="icon-iconmenu-uploadCSV" icon variant="text" density="comfortable" v-bind="props">
                      <v-icon size="22">mdi-dots-horizontal</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item id="list-duplicate-uploadCSV" @click="popupDuplicate(item.vectorDBName, item.id || item.ID)">
                      <v-list-item-title>{{
                        $t("vector_management_duplicate")
                        }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item id="list-replace-uploadCSV" @click="popupReplace(item.vectorDBName)">
                      <v-list-item-title>{{
                        $t("vector_management_replace")
                        }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item id="list-version-history-uploadCSV" @click="Version(item.vectorDBName)">
                      <v-list-item-title>{{
                        $t("gpt_model_management_version_history")
                        }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
              <td style="text-align: center">{{ item.createBy }}</td>
              <td style="text-align: center; padding: 8px 0;">
                <div class="personal-info-switch-container">
                  <v-switch id="publication-header-switch"
                    v-model="item.personalInformation" hide-details inset
                    @change="UpdatePersonalInformation(item)"
                    density="comfortable" :class="[
                    'publication-toggle','personal-switch',
                    item.personalInformation
                      ? 'publication-toggle--active'
                      : 'publication-toggle--inactive'
                  ]">
                  <template v-slot:prepend>
                      <v-tooltip location="top" :text="$t('_togglePersonalInfoDetection')">
                        <template v-slot:activator="{ props }">
                          <img v-bind="props" :src="item.personalInformation ? images.guardActive : images.guardInactive" alt="Guard Icon"
                            class="personal-icon" />
                        </template>
                      </v-tooltip>
                    </template>
                  </v-switch>
                </div>
              </td>
              <td style="text-align: center; padding: 12px">
                <!-- Process Status with compact design -->
                <div class="d-flex justify-center">
                  <div class="status-container">
                    <v-chip :color="getProcessStatusColor(item)" variant="elevated" size="small" class="status-chip text-white">
                      <v-icon start size="14">
                        {{ getProcessStatusIcon(item) }}
                      </v-icon>
                      <span class="status-text">{{ item.inProcess }}/{{ item.inProcessMax }}</span>
                    </v-chip>
                  </div>
                </div>
              </td>
              <td style="text-align: center; padding: 12px">
                <!-- Minimal action buttons -->
                <div class="action-container">
                  <div class="action-group">
                    <!-- Minimal reprocess button -->
                    <v-btn id="button-reprocess-uploadCSV" variant="flat" size="small" :disabled="
                        item.inProcess >= item.inProcessMax && !item.isError
                      " @click="Reprocess(item)" class="minimal-btn" icon>
                      <img :src="images.reprocess" alt="Reprocess" style="width: 25px; height: 25px;" />
                      <v-tooltip activator="parent" location="top">
                        {{ $t("reprocessDocument") }}
                      </v-tooltip>
                    </v-btn>
                    <!-- Edit -->
                     <!-- Edit Button -->
                    <v-btn id="button-edit-uploadCSV" variant="text" density="comfortable"
                      @click="Edit(item)" class="action-btn edit-btn" icon>
                      <img :src="images.edit" alt="Edit" style="width: 25px; height: 25px;" />
                      <v-tooltip activator="parent" location="top">
                        {{ $t("edit") }}
                      </v-tooltip>
                    </v-btn>

                    <!-- Download -->
                    <v-btn id="button-download-uploadCSV" variant="text" density="comfortable"
                      @click="DownloadCSV(item)" :disabled="item.inProcess != item.inProcessMax || !item.isError"
                      class="action-btn download-btn" icon>
                      <img :src="images.download" alt="Download" style="width: 25px; height: 25px;" />
                      <v-tooltip activator="parent" location="top">
                        {{ $t("Download") }}
                      </v-tooltip>
                    </v-btn>
                    <!-- Delete -->
                    <v-btn id="button-delete-uploadCSV" variant="text" density="comfortable"
                      @click="DeleteByName(item.vectorDBName)" class="action-btn delete-btn" icon
                      :disabled="item.inProcess != item.inProcessMax || !item.isError || btnDisableDelete(item)">
                      <img :src="images.delete" alt="Delete" style="width: 25px; height: 25px;" />
                      <v-tooltip activator="parent" location="top">
                        {{ $t("delete") }}
                      </v-tooltip>
                    </v-btn>
                  </div>
                </div>
              </td>
            </tr>
          </template>
          <template v-slot:bottom>
            <div
              class="d-flex justify-space-between align-center px-4 py-2"
              style="width: 100%"
            >
              <div>{{ $t("totalResults") }} {{ searchTotalTable }}</div>

              <v-data-table-footer
                :items-per-page-options="[10, 20, 50]"
                :page="options.page"
                :length="Math.ceil(searchTotalTable / itemsPerPage)"
              />
            </div>
          </template>
        </v-data-table-server>

      </v-card>
    </v-container>
    <v-dialog v-model="dialog_duplicate" persistent max-width="600px" class="modern-dialog">
      <v-card>
          <div class="dialog-header-doc">
            <div class="header-main">
              <div>
                <h2 style="font-weight: 600;">{{ $t("vector_duplicate") }}</h2>
              </div>
            </div>
            <div class="header-actions">
              <v-btn icon variant="text" @click="dialog_duplicate = false" class="close-btn">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
        <v-card-text class="pt-3 pl-4 pr-4 pb-1">
          <v-container>
            <v-form ref="form" lazy-validation>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <span>{{ $t("_setNameForDuplicateDoc") }}</span>
                  <v-text-field id="input-vectordbName-uploadCSV" @keypress="handleKeypress" :label="$t('documentName')" color="#C32E0E"
                    v-model="newvectordbName" :rules="[rules.required]" required variant="outlined" class="modern-input"></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="dialog-actions d-flex justify-end">
          <v-btn text @click="dialog_duplicate = false" class="delete-cancel-btn-1" color="error">
            <v-icon>mdi-close</v-icon>
            {{$t("close")}}
          </v-btn>
          <v-btn id="button-save-vectordbName-uploadCSV" class="dialog-action-btn save-btn-edit" text @click="SaveDuplicateVector">
            <img :src="images.save" alt="Save" class="white-svg" />
            {{$t("save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_replace" persistent max-width="600px" class="modern-dialog">
      <v-card>
          <div class="dialog-header-doc">
            <div class="header-main">
              <div>
                <h2 style="font-weight: 600;">{{ $t("_replaceDoc") }}</h2>
              </div>
            </div>
            <div class="header-actions">
              <v-btn icon variant="text" @click="dialog_replace = false" class="close-btn">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
        <v-card-text class="pa-2">
          <v-container>
            <v-form ref="form" lazy-validation>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <h3 style="font-weight: 600;" class="mb-2"> {{ selectvectordbname }} >></h3>
                  <span>{{ $t("_selectDocToReplace") }}</span>
                  <v-autocomplete id="input-replacevectorname-uploadCSV" :label="$t('documentName')" :rules="[rules.required]" color="#C32E0E"
                    :items="filterlistDDLVector" item-text="id" item-title="name" v-model="replacevectorname" clearable variant="outlined" class="modern-input replace-mdi-bfe"
                    outlined required>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="dialog-actions d-flex justify-end">
          <v-btn text @click="dialog_replace = false" class="delete-cancel-btn-1">
            <v-icon>mdi-close</v-icon>
            {{$t("close")}}
          </v-btn>
          <v-btn id="button-save-replacevector-uploadCSV" class="dialog-action-btn save-btn-edit" text @click="SaveReplaceVector">
            <img :src="images.save" alt="Save" class="white-svg" />
            {{$t("save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_version" persistent max-width="800px" class="modern-dialog">
      <v-card>
          <div class="dialog-header-doc">
            <div class="header-main">
              <div>
                <h2 style="font-weight: 600;">{{ $t("gpt_model_management_version_history") }}</h2>
              </div>
            </div>
            <div class="header-actions">
              <v-btn icon variant="text" @click="dialog_version = false" class="close-btn">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
        <v-card-text class="pa-2">
          <v-container>
            <v-data-table-server id="table-popup-versionhistory-uploadCSV" v-model:options="options_version"
              v-model:items-per-page="itemsPerPage_version" :items-length="searchTotalTable_version" :items="menus_version"
              :headers="headers_version_history">
              <template v-slot:item="{ item, index }">
                <tr>
                  <td style="text-align: left">{{ item.version }} 
                    <div v-if="index === 0 && (options_version.page === 1 || !options_version.page)" style="display: inline-flex;
                        padding: 4px 8px;
                        justify-content: center;
                        align-items: center;
                        gap: 10px; border-radius: 4px;
                        width: 48px;
                        height: 20px;
                        background: var(--btn-bg, linear-gradient(90deg, #C32E0E 0%, #F67760 100%));">
                      <span style="color:azure; font-size: 12px;">{{ $t("latest") }}</span>
                    </div>
                  </td>
                  <td style="text-align: left">{{ item.createDate }}</td>
                  <td style="text-align: center">
                    <v-menu location="bottom">
                      <template v-slot:activator="{ props }">
                        <v-btn id="button-menu-versionhistory-uploadCSV" icon v-bind="props" variant="text">
                          <v-icon size="22">mdi-dots-horizontal</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item id="button-menu-restore-uploadCSV" :key="item.id" @click="
                            changeRestoreNewVersion(item.id, item.vectordbName)
                          ">
                          <v-list-item-title>{{ $t("restore") }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item id="button-menu-view-uploadCSV" @click="view(item.vectordbName, item.id)">
                          <v-list-item-title>{{ $t("view") }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </td>
                  <td style="text-align: left">{{ item.createBy }}</td>
                </tr>
              </template>
              <template v-slot:bottom>
                <div
                  class="d-flex justify-space-between align-center px-4 py-2"
                  style="width: 100%"
                >
                  <div>{{ $t("totalResults") }} {{ searchTotalTable_version }}</div>

                  <v-data-table-footer
                    v-model:items-per-page="itemsPerPage_version"
                    :items-per-page-options="[5, 10, 20, 50]"
                    :page="options_version.page"
                    :length="Math.ceil(searchTotalTable_version / itemsPerPage_version)"
                  />
                </div>
              </template>
            </v-data-table-server>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!--dialog view vector version-->
    <v-dialog v-model="dialog_view" width="80vw">
      <v-card>
        <div class="dialog-header ">
            <div class="header-main">
              <div>
                <h2 style="font-weight: 600;">{{ $t("gpt_model_management_version_history_detail") }}</h2>
              </div>
            </div>
            <div class="header-actions">
              <v-btn icon variant="text" @click="closeViewModel()" class="close-btn">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
        <v-card-text class="pa-2">
          <v-container>
            <v-data-table-server v-model:options="options3" :items-per-page="itemsPerPage2"
              :items-length="searchTotalTable_view_model" :items="view_model" :headers="headers2"
              :loading="loadingTable" :loading-text="$t('_Loading')" fixed-header mobile-breakpoint="300"
              class="elevation-1 responsive-table">
              <template v-slot:item.textORG="{ item }">
                <div class="text-container wrap-text">
                  {{ item.textORG }}
                </div>
              </template>
              <template v-slot:item.textEN="{ item }">
                <div class="text-container wrap-text">
                  {{ item.textEN }}
                </div>
              </template>
            </v-data-table-server>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Custom Reprocess Dialog -->
    <v-dialog v-model="dialog_reprocess" max-width="600px" persistent>
      <v-card class="delete-dialog-card">
        <div class="delete-dialog-header">
          <span class="reprocess-dialog-title">{{ $t("reprocessDocument") }}</span>
          <v-btn
            icon
            variant="text"
            size="small"
            class="delete-close-icon"
            @click="cancelReprocess"
          >
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
        
        <!-- Content -->
        <v-card-text class="delete-dialog-content">
          <span style="font-weight: 500;">
            {{ $t("_confirmReprocessDocument") }}
          </span>
        </v-card-text>
        
        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn
            class="delete-cancel-btn"
            @click="cancelReprocess"
          >
            {{ $t("cancel") }}
          </v-btn>
          <v-btn
            class="reprocess-confirm-btn"
            @click="confirmReprocess"
          >
            <img :src="images.reprocess1" alt="Reprocess" class="white-svg" />
            {{ $t("reprocess") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Custom Delete Dialog -->
    <v-dialog v-model="dialog_delete" max-width="600px" persistent>
      <v-card class="delete-dialog-card">
        <div class="delete-dialog-header">
          <span class="delete-dialog-title">{{ $t("deleteDocument") }}</span>
          <v-btn
            icon
            variant="text"
            size="small"
            class="delete-close-icon"
            @click="cancelDelete"
          >
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
        
        <!-- Content -->
        <v-card-text class="delete-dialog-content">
          <span style="font-weight: 500;" v-if="deleteItem">
            {{ $t("_confirmDeleteDocument") }}
          </span>
        </v-card-text>
        
        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn
            class="delete-cancel-btn"
            @click="cancelDelete"
          >
            {{ $t("cancel") }}
          </v-btn>
          <v-btn
            class="delete-confirm-btn"
            @click="confirmDelete"
          >
            <img :src="images.trashBin" alt="Delete" class="white-svg" />
            {{ $t("delete") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Loading Please Wait... -->
    <v-overlay :model-value="dialog" class="align-center justify-center">
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular indeterminate size="64" color="primary" class="mb-4"></v-progress-circular>
          <h3 class="loading-title">{{ $t("_Loading") }}</h3>
          <p class="loading-subtitle">{{ $t("pleaseWait") }}</p>
        </v-card-text>
      </v-card>
    </v-overlay>
  </div>
</template>
<script>
import checkPermissionTwo from "@/api/function.js";
import editImg from "@/assets/images/editbutton.png";
import deleteImg from "@/assets/images/trashbutton.png";
import reprocessImg from "@/assets/images/Reprocess.png";
import downloadImg from "@/assets/images/downloadnew.png";
import SaveImg from "@/assets/mage_save-floppy.svg";
import ReprocessImg1 from "@/assets/file-settings-line.svg";
import GuardActiveImg from "@/assets/images/Vector.png";
import GuardInactiveImg from "@/assets/images/Vectorinactive.png";
import TrashBinImg from "@/assets/images/trash-solid.svg";
export default {
  name: "UploadCSV",
  inject: [
    "flagNav",
    "FontColorTitle",
    "SubNavbarBackGround",
    "Username",
    "RoleId"
  ],
  mixins: [checkPermissionTwo],
  data: () => ({
    uploadDialog: false,
    checkbox1: false,
    EditdialogUser: false,
    AddVector: false,
    dialog: false,
    loadingTable: false,
    loading: true,
    loadingDownload: true,
    dialog_delete: false,
    dialog_reprocess: false,
    reprocessSource: null,
    deleteItem: null,
    today: null,
    searchVectorDBName: null,
    searchVectorProcess: 0,
    searchVectorDBName2: null,
    requestVector: {
      modelType: null,
      modelId: null,
      vectordbName: null,
      entity: null,
      deleteAll: true,
    },
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    images: {
      edit: editImg,
      delete: deleteImg,
      reprocess: reprocessImg,
      download: downloadImg,
      save: SaveImg,
      reprocess1: ReprocessImg1,
      guardActive: GuardActiveImg,
      guardInactive: GuardInactiveImg,
      trashBin: TrashBinImg,
    },
    options3: { page: 1, itemsPerPage: 10, sortBy: [null], sortDesc: [null] },
    DDModel: [],
    files: [],
    dataTable: [],
    dataTable2: [],
    isSearch: false,
    isSearch2: false,
    isFirst: true,
    isFirst2: true,
    searchTotalTable: 0,
    totalTable: 0,
    itemsPerPage: 10,

    searchTotalTable2: 0,
    totalTable2: 0,
    itemsPerPage2: 10,
    showTable: false,
    sortBy: [],
    sortDesc: [],
    dialog_duplicate: false,
    dialog_replace: false,
    listDDLVector: [],
    filterlistDDLVector: [],
    duplicatesourceheadid: null,
    duplicatevectorname: null,
    replacevectorname: null,
    newvectordbName: null,
    selectvectordbname: null,

    vesionvectordbname: null,
    options_version: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    dialog_version: false,
    itemsPerPage_version: 5,
    menus_version: [],
    menus_modelid_version: 0,
    menus_modeliddisplay_version: 0,
    searchTotalTable_version: 0,
    totalTable_version: 0,
    //dialogview
    view_model: [],
    dialog_view: false,
    searchTotalTable_view_model: 0,
    totalTable_view_model: 0,
  }),
  computed: {
    rules() {
      return {
        required: (value) => !!value || this.$t("requiredField"),
      };
    },
    headers() {
      return [
        { title: this.$t("no"), align: "center", sortable: false },
        {
          title: this.$t("documentName"),
          value: "vectordbname",
          align: "left",
          sortable: true,
        },
        { title: " ", value: " ", align: "center", sortable: false },
        {
          title: this.$t("createdBy"),
          value: "create_by",
          align: "center",
          sortable: true,
        },
        { title: this.$t("personalInfo"), align: "center", sortable: false },
        { title: this.$t("progressStatus"), align: "center", sortable: false },
        // { title: "Reprocess", align: "center", sortable: false },
        { title: this.$t("manage"), align: "center", sortable: false },
        // { text: this.$t('delete'), align: 'center', sortable: false },
      ];
    },
    headers_version_history() {
      return [
        { title: this.$t("versionLabel"), align: "left", sortable: false, width: "95px" },
        { title: this.$t("modified"), align: "left", sortable: false },
        { title: " ", align: "center", sortable: false },
        { title: this.$t("modifiedBy"), align: "left", sortable: false },
      ];
    },
    headers2() {
      return [
        {
          title: this.$t("no"),
          value: "number",
          align: "center",
          justify: "center",
          sortable: false,
          width: "100px",
          class: "wrap-text",
        },
        {
          title: this.$t("originalText"),
          value: "textORG",
          align: "center",
          sortable: true,
          width: "100px",
          class: "wrap-text",
        },
        {
          title: this.$t("englishText"),
          value: "textEN",
          align: "center",
          sortable: true,
          width: "100px",
          class: "wrap-text",
        },
      ];
    },
  },
  watch: {
    searchVectorDBName(newValue) {
      if (typeof newValue === "string" && newValue.length > 1000) {
        this.searchVectorDBName = newValue.slice(0, 1000);
      }
    },
    options: {
      handler() {
        this.Get();
      },
      deep: true,
      immediate: true,
    },
    options_version: {
      handler() {
        this.Version(this.vesionvectordbname);
      },
      deep: true,
    },
    options3: {
      handler() {
        this.view(this.vesionvectordbname, this.vectorID);
      },
      deep: true,
    },
    dialog_view(newVal) {
      if (newVal) {
        // เมื่อปิด dialog ให้รีเซ็ต page และ view_model
        this.options3.page = 1;
        this.view_model = [];
      }
    },
  },
  methods: {
    formatText(text) {
      // แปลงช่องว่างเป็น &nbsp; เพื่อให้รักษาช่องว่างได้
      return text.replaceAll(' ', "&nbsp;");
    },
    Get() {
      this.loadingTable = true;

      let { page, itemsPerPage, sortBy } = this.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === "desc";
      }

      let temp = {
        page: this.isSearch ? 1 : page,
        perPage: itemsPerPage == -1 ? this.totalTable : itemsPerPage,
        name: this.searchVectorDBName,
        sortDesc: sortOrder,
        sortBy: sortField,
      };
      this.$call.GetVectorDBName(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.searchTotalTable = dataResponse.data.total;
            this.dataTable = dataResponse.data.data;
            this.totalTable = this.isFirst
              ? dataResponse.data.total
              : this.totalTable;
            if (!this.isFirst) {
              this.AutoRefresh();
            }
          } else {
            this.dataTable = [];
            this.searchTotalTable = 0;
            this.totalTable = 0;
          }
          this.loadingTable = false;
          this.isSearch = false;
          this.isFirst = false;
        },
        (errorResource) => {
          this.loadingTable = false;
          this.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    GetDefault() {
      this.dialog = true;
      this.loading = true;
      let { itemsPerPage } = this.options;
      let temp = {
        page: 1,
        perPage: itemsPerPage == -1 ? this.totalTable : itemsPerPage,
        name: this.searchVectorDBName,
        sortDesc: null,
        sortBy: null,
      };
      this.$call.GetVectorDBName(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.searchTotalTable = dataResponse.data.total;
            this.dataTable = dataResponse.data.data;
            this.totalTable = this.isFirst
              ? dataResponse.data.total
              : this.totalTable;
            if (!this.isFirst) {
              console.log(this.isFirst);
              this.AutoRefresh();
            }
          } else {
            this.dataTable = [];
            this.searchTotalTable = 0;
            this.totalTable = 0;
          }
          this.dialog = false;
          this.isSearch = false;
          this.isFirst = false;
        },
        (errorResource) => {
          this.dialog = false;
          this.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    ReFreshGet() {
      this.loading = true;
      let { page, itemsPerPage } = this.options;
      let temp = {
        page: this.isSearch ? 1 : page,
        perPage: itemsPerPage == -1 ? this.totalTable : itemsPerPage,
        name: this.searchVectorDBName,
      };
      this.$call.GetVectorDBName(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.searchTotalTable = dataResponse.data.total;
            this.dataTable = dataResponse.data.data;
            this.totalTable = this.isFirst
              ? dataResponse.data.total
              : this.totalTable;
          } else {
            this.dataTable = [];
            this.searchTotalTable = 0;
            this.totalTable = 0;
          }
          this.isSearch = false;
          this.isFirst = false;
        },
        (errorResource) => {
          this.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    Search() {
      this.isSearch = true;
      this.options.page = 1;
      this.GetDefault();
    },
    Save() {
      if (
        !this.requestVector.modelType ||
        !this.searchVectorDBName2 ||
        !this.requestVector.entity
      ) {
        alert(this.$t("_pleaseFillAllFields"));
        return;
      }
      this.requestVector.vectordbName = this.searchVectorDBName2;
      this.dialog = true;
      try {
        this.$call.UploadCSV2Vector(
          this.requestVector,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              let msgSuccess = "✔ " +
                dataResponse.message;
              this.$swal.fire({
                title: msgSuccess,
                showConfirmButton: false,
                timer: 1500,
                position: 'top',
                customClass: {
                        popup: 'success-banner',
                        title: 'success-banner-title'
                      },
              });
              this.Clear();
            }
            this.dialog = false;
          },
          (errorResource) => {
            this.dialog = false;
            this.AddVector = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    back(e) {
      if (e) {
        this.EditdialogUser = false;
        this.AddVector = false;
      }
    },
    Reprocess(source) {
      this.dialog_reprocess = true;
      this.reprocessSource = source;
    },
    confirmReprocess(){
      if (!this.reprocessSource) return;
      this.dialog_reprocess = false;
      this.dialog = true;
      try {
        let data = {
          vectordbName: this.reprocessSource.vectorDBName,
        };
        this.$call.ReProcessedVector(
          data,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              this.reprocessSource.isError = false;
              this.Get();
              let msgSuccess = "✔ " +
                dataResponse.message;
              this.$swal.fire({
                title: msgSuccess,
                showConfirmButton: false,
                timer: 1500,
                position: 'top',
                customClass: {
                        popup: 'success-banner',
                        title: 'success-banner-title'
                      },
              });
            }
            this.dialog = false;
          },
          (errorResource) => {
            this.dialog = false;
            console.error(errorResource.message);
          }
        );
      } catch (error) {
        this.LogTrace(error, "ReProcess");
      }
    },
    processUpload(e) {
      this.files = e;
      if (this.files.length == 0) {
        this.requestVector.entity = null;
        return;
      }
      const reader = new FileReader();
      reader.readAsText(this.files[0]); //NOSONAR
      reader.onload = () => {
        let text = reader.result;
        this.ValidateCSVVector(text, this.files);
      };
    },
    ValidateCSVVector(csv, files) {
      let temp = csv.replaceAll("\r", "");
      let lines = temp.split("\n");
      if (lines[0] == "text_org,text_en") {
        const formDataDoc = new FormData();
        formDataDoc.append("entity", files[0]);
        this.requestVector.entity = formDataDoc;
      } else {
        this.requestVector.entity = null;
        alert(this.$t("_pleaseEnterCorrectFormat"));
      }
    },
    DeleteByName(name) {
      this.deleteItem = name;
      this.dialog_delete = true;
    },
    confirmDelete() {
      if (!this.deleteItem) return;
      const name = this.deleteItem
      try {
        this.dialog_delete = false;
        this.dialog = true;
        this.$call.DeleteVectorDBNameByName(
                name,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    let msgSuccess = "✔ " +
                      dataResponse.message;
                    this.$swal.fire({
                      title: msgSuccess,
                      showConfirmButton: false,
                      timer: 1500,
                      position: 'top',
                      customClass: {
                              popup: 'success-banner',
                              title: 'success-banner-title'
                            },
                    });
                    this.Get();
                    this.GetDDLVector();
                  }else if (dataResponse.status == 1) {
                    this.$swal.fire({
                      icon: "error",
                      title: dataResponse.message,
                      showConfirmButton: true,
                      confirmButtonText: this.$t("gotIt"),
                      confirmButtonColor: "#d33",
                    });
                  }
                  this.dialog = false;
                },
                (errorResource) => {
                  this.dialog = false;
                  this.Adddialog = false;
                  console.error(errorResource);
                }
              );
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
        this.dialog_delete = false;
        this.deleteItem = null;
      }
    },
    cancelReprocess() {
      this.dialog_reprocess = false;
      this.reprocessSource = null;
    },
    cancelDelete() {
      this.dialog_delete = false;
      this.deleteItem = null;
    },
    Add() {
      this.$router.push({
        name: "UploadVector",
        query: {
          name: null,
        },
      });
    },
    Edit(item) {
      this.$router.push({
        name: "UploadVector",
        query: {
          name: item.vectorDBName,
        },
      });
    },

    DownloadCSV(item) {
      this.dialog = true;
      // this.$call.GetVectorCSVExport(
      this.$call.GetVectorExcelExport(
        item.vectorDBName,
        (dataResponse) => {
          if (dataResponse) {
            let fileURL = globalThis.URL.createObjectURL(new Blob([dataResponse]));
            let fileLink = document.createElement("a");

            fileLink.href = fileURL;
            let fileName = `${item.vectorDBName}_${this.convertDateToString(
              new Date(),
              ""
            )}.xlsx`;
            fileLink.setAttribute("download", fileName);
            document.body.appendChild(fileLink);

            fileLink.click();
          }
          this.dialog = false;
        },
        (errorResource) => {
          this.dialog = false;
          this.isSearch = false;
          console.error(errorResource);
        }
      );
    },


    Clear() {

      this.EditdialogUser = false;
      this.AddVector = false;
      this.showTable = false;

      this.requestVector.entity = null;
      this.requestVector.modelId = null;
      this.requestVector.modelType = null;
      this.requestVector.vectordbName = null;

      this.searchVectorDBName = null;
      this.searchVectorDBName2 = null;
      this.dataTable2 = [];
      this.searchTotalTable2 = 0;
      this.totalTable2 = 0;
    },
    download() {
      const data = [];
      data.push(
        "text_org,text_en\n",
        "ชื่อบทความ (วรรณคดี): พระอภัยมณี,\n",
        "Article Title (Literature): Phra Abhayamani,\n",
        "Article Title (Literature): Phra Abhayamani (พระอภัยมณี),"
      );

      const a = document.createElement("a");
      let blob = new Blob(data, { type: "data:text/csv;charset=utf-8" });
      const url = globalThis.URL.createObjectURL(blob);

      a.href = url;
      a.download = "upload_vector.csv";
      a.click();
      globalThis.URL.revokeObjectURL(url);
      a.remove();
    },
    async AutoRefresh() {
      let death_waiting = true;
      do {
        for (let value of this.dataTable) {
          if (value.inProcess < value.inProcessMax && !value.isError) {
            this.ReFreshGet();
            death_waiting = true;
            break;
          } else {
            death_waiting = false;
          }
        }
        if (globalThis.location.pathname != "/VectorManagement") {
          death_waiting = false;
        }
        await new Promise((resolve) => setTimeout(resolve, 5000));
      } while (death_waiting);
    },

    GetDDLVector() {
      this.$call.GetDDLVector(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.listDDLVector = dataResponse.data;
          } else {
            this.listDDLVector = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },

    popupDuplicate(vectorDBName, sourceHeadId) {
      this.dialog_duplicate = true;
      this.newvectordbName = null;
      this.duplicatevectorname = vectorDBName;
      this.duplicatesourceheadid = sourceHeadId || null;
    },
    SaveDuplicateVector() {
      if (
        !this.newvectordbName ||
        !this.newvectordbName.trim() ||
        (!this.duplicatevectorname && !this.duplicatesourceheadid)
      ) {
        alert(this.$t("_pleaseFillAllFields"));
        return;
      }
      this.dialog = true;
      let req = {
        sourceHeadId: this.duplicatesourceheadid,
        vectordbname: this.duplicatevectorname,
        newvectordbname: this.newvectordbName.trim(),
      };
      try {
        this.$call.SaveDuplicateVector(
          req,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              let msgSuccess = "✔ " +
                dataResponse.message;
              this.$swal.fire({
                title: msgSuccess,
                showConfirmButton: false,
                timer: 1500,
                position: 'top',
                customClass: {
                        popup: 'success-banner',
                        title: 'success-banner-title'
                      },
              });
              this.newvectordbName = null;
              this.Get();
              this.GetDDLVector();
            } else {
              this.$swal.fire({
                icon: "error",
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 2500,
              });
            }
            this.dialog = false;
            this.dialog_duplicate = false;
          },
          (errorResource) => {
            this.dialog = false;
            this.dialog_duplicate = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "SaveDuplicateVector");
      }
    },

    popupReplace(vectorDBName) {
      this.dialog_replace = true;
      this.selectvectordbname = vectorDBName;
      this.filterlistDDLVector = this.listDDLVector.filter(
        (o) => o.name != vectorDBName
      );
    },
    SaveReplaceVector() {
      if (this.replacevectorname == null) {
        alert(this.$t("_pleaseFillAllFields"));
        return;
      }
      this.dialog = true;
      let req = {
        selectvectordbname: this.selectvectordbname,
        replacevectordbname: this.replacevectorname,
      };
      try {
        this.$call.SaveReplaceVector(
          req,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              let msgSuccess = "✔ " +
                dataResponse.message;
              this.$swal.fire({
                title: msgSuccess,
                showConfirmButton: false,
                timer: 1500,
                position: 'top',
                customClass: {
                        popup: 'success-banner',
                        title: 'success-banner-title'
                      },
              });
              this.Get();
              this.GetDDLVector();
            }
            this.dialog = false;
            this.dialog_replace = false;
          },
          (errorResource) => {
            this.dialog = false;
            this.dialog_replace = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "SaveReplaceVector");
      }
    },
    handleKeypress(evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      // กำหนด Regular Expression สำหรับตรวจสอบตัวอักษรไทย, อังกฤษ, และตัวเลข
      const validCharactersRegex = /^[a-zA-Z0-9\u0E00-\u0E7F]+$/;

      if (validCharactersRegex.test(String.fromCodePoint(charCode))) {
        return true;
      } else {
        evt.preventDefault();
      }
    },
    async Version(vectordbName) {
      this.dialog = true;
      this.loading = true;
      this.vesionvectordbname = vectordbName;

      if (!this.dialog_version) {
        this.options_version.page = 1;
      }

      this.dialog_version = true;

      const { page, itemsPerPage } = this.options_version;
      const resolvedPerPage = itemsPerPage || this.itemsPerPage_version || 10;
      let temp = {
        page: page == undefined ? 1 : page,
        perPage: resolvedPerPage == -1 ? (this.totalTable_version || 1000) : resolvedPerPage,
        vectordbName: vectordbName,
      };

      this.$call.GetTableVectorVersion(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.menus_version = dataResponse.data.data;
            this.searchTotalTable_version = dataResponse.data.total;
            this.totalTable_version = dataResponse.data.total;
          } else {
            this.menus_version = [];
            this.searchTotalTable_version = 0;
            this.totalTable_version = 0;
          }
          this.dialog = false;
        },
        (errorResource) => {
          this.dialog = false;
          this.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    changeRestoreNewVersion(id, vectordbName) {
      this.dialog = true;
      this.loading = true;
      let req = {
        ID: id,
        vectordbName: vectordbName,
      };
      this.$call.SaveReStoreVector(
        req,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.Get();
          }
          this.dialog_version = false;
          this.dialog = false;
          return null;
        },
        (errorResource) => {
          this.dialog = false;
          this.isSearch = false;
          this.dialog_version = false;
          console.error(errorResource);
          return null;
        }
      );
    },
    view(vectordbName, id) {
      this.dialog_view = true;
      this.dialog = true;
      let { page, itemsPerPage } = this.options3;
      this.sortBy =
        this.options3.sortBy == undefined || this.options3.sortBy.length == 0
          ? null
          : this.options3.sortBy[0];
      this.sortDesc =
        this.options3.sortDesc == undefined ||
        this.options3.sortDesc.length == 0
          ? null
          : this.options3.sortDesc[0];
      this.vesionvectordbname = vectordbName;
      this.vectorID = id;
      let temp = {
        page: this.isSearch ? 1 : page,
        perPage: itemsPerPage == -1 ? null : itemsPerPage,
        name: vectordbName,
        id: id,
        text_org: null,
        sortDesc: this.sortDesc,
        sortBy: this.sortBy,
      };
      this.$call.ReFreshViewVector(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.view_model = dataResponse.data.table.data;
            this.searchTotalTable_view_model = dataResponse.data.table.total;
            this.totalTable_view_model = dataResponse.data.table.total;
          } else {
            this.view_model = [];
            this.searchTotalTable_view_model = 0;
            this.totalTable_view_model = 0;
          }
          this.isSearch = false;
          this.dialog = false;
        },
        (errorResource) => {
          this.dialog = false;
          this.dialog_view = false;
          this.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    closeViewModel() {
      this.dialog_view = false;
    },
    getProcessStatusColor(item) {
      if (item.inProcess === item.inProcessMax) return "#2ABF56";
      if (item.inProcess > 0) return "#EABD07";
      return "grey";
    },

    getProcessStatusIcon(item) {
      if (item.inProcess === item.inProcessMax) return "mdi-check-circle";
      if (item.inProcess > 0) return "mdi-clock-outline";
      return "mdi-circle-outline";
    },
    UpdatePersonalInformation(item) {
      this.dialog = true;
      const parameter = {
        VectorDBName: item.vectorDBName
      }
      this.$call.UpdatePersonalInformation(
        parameter,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            let msgSuccess = "✔ " +
              dataResponse.message;
            this.$swal.fire({
              title: msgSuccess,
              showConfirmButton: false,
              timer: 1500,
              position: 'top',
              customClass: {
                      popup: 'success-banner',
                      title: 'success-banner-title'
                    },
            });
            this.Get();
          }
          this.dialog = false;
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      );
    },

    btnDisableDelete(item) {
      return (this.RoleId == 2 || this.RoleId == 6) && item.createBy != this.Username;
    }
  },

  mounted() {
    this.GetDate();
    this.GetDDLVector();
  },
};
</script>
<style scoped>
.card2 {
  border-radius: 16px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08) !important;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.card {
  border-radius: 16px !important;
  margin-bottom: 2rem;
  height: 90vh;
  overflow: auto;
  padding: 0;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

.wrap-text {
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

/* Minimal Status Badge */
.status-badge {
  position: relative;
}

.status-avatar {
  border: 2px solid white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.modern-input :deep(.v-field) {
  border-radius: 16px;
  transition: all 0.2s ease;
  margin-top: 10px;
}
/* Dialog Actions */
.dialog-actions {
  background: white;
  padding: 1.5rem 2rem;
  border-top: 1px solid #e0e0e0;
}

/* Minimal Reprocess Button */
.minimal-btn {
  border-radius: 50% !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  background: white !important;
}

.minimal-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.minimal-btn:disabled {
  opacity: 0.4;
  transform: none !important;
  box-shadow: none !important;
}

/* Action Divider */
.action-divider {
  width: 1px;
  height: 20px;
  background: rgba(0, 0, 0, 0.12);
  margin: 0 4px;
  align-self: center;
  border-radius: 1px;
}

.action-group:hover .action-divider {
  background: rgba(0, 0, 0, 0.2);
}

/* Table improvements */
:deep(.v-data-table-server) {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
:deep(thead) {
  background-color: #FFE4E1 !important;
}
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
:deep(.v-data-table__wrapper) {
  border-radius: 12px;
}

:deep(.v-data-table tbody tr) {
  transition: background-color 0.2s ease;
}

:deep(.v-data-table tbody tr:hover) {
  background-color: rgba(0, 0, 0, 0.02) !important;
}

:deep(.v-data-table-header) {
  background: rgba(0, 0, 0, 0.02);
}

:deep(.v-data-table-header th) {
  font-weight: 600 !important;
  color: rgba(0, 0, 0, 0.7) !important;
  font-size: 0.875rem !important;
  letter-spacing: 0.025em;
}

/* Search panel improvements */
.search-panel {
  border: 1px solid rgba(0, 0, 0, 0.06) !important;
  border-radius: 12px !important;
  background: rgba(0, 0, 0, 0.01);
}

/* Button improvements */
.action-button {
  border-radius: 12px !important;
  font-weight: 500;
  letter-spacing: 0.025em;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12) !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.action-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

/* Header improvements */
:deep(.v-toolbar) {
  border-radius: 12px !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12) !important;
}

/* Responsive design */
@media (max-width: 768px) {
  .action-group {
    flex-direction: column;
    gap: 2px;
    padding: 2px;
  }

  .status-avatar {
    width: 28px !important;
    height: 28px !important;
  }

  .action-btn {
    width: 32px;
    height: 32px;
  }
}

/* Smooth animations */
* {
  transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease,
    opacity 0.2s ease;
}

/* Loading states */
.v-skeleton-loader {
  border-radius: 12px !important;
}

/* Focus states */
.action-btn:focus-visible {
  outline: 2px solid rgb(25, 118, 210);
  outline-offset: 2px;
}

/* Custom scrollbar */
:deep(.v-data-table__wrapper)::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

:deep(.v-data-table__wrapper)::-webkit-scrollbar-track {
  background: transparent;
}

:deep(.v-data-table__wrapper)::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

:deep(.v-data-table__wrapper)::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

:deep(
.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-left .v-data-table-header__content span, 
) { font-weight: 600; font-size: 15px; }
:deep(
.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span, 
) { font-weight: 600; font-size: 15px; }
/* Action Controls */
.action-controls {
  display: flex;
  align-items: center;
  border-radius: 12px;
  padding: 4px 8px;
  transition: all 0.2s ease;
  min-width: 200px;
}

.action-controls:hover {
  background: rgba(0, 0, 0, 0.03);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.refresh-btn {
  margin-left: 9px;
  opacity: 0.7;
}

.refresh-btn:hover {
  opacity: 1;
  background: rgba(0, 0, 0, 0.06) !important;
}

.add-btn {
  width: 150px;
  box-shadow: 0 1px 3px rgba(25, 118, 210, 0.2);
}

.add-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(25, 118, 210, 0.3);
}

/* Minimal Action Button (แบบแรก) */
.minimal-action-btn {
  border-radius: 50% !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 0.7;
}

.minimal-action-btn:hover {
  opacity: 1;
  background: rgba(0, 0, 0, 0.06) !important;
  transform: scale(1.1) rotate(180deg);
}

.create-btn {
  box-shadow: 0 1px 3px rgba(25, 118, 210, 0.2);
  font-weight: 500;
  letter-spacing: 0.025em;
}

.create-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(25, 118, 210, 0.3);
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .action-controls {
    width: 100%;
    justify-content: space-between;
  }

  .control-btn {
    flex: 1;
    margin: 0 2px;
  }
  .status-chip {
    min-width: 70px;
    font-size: 0.7rem;
  }

  .status-text {
    font-size: 0.7rem;
  }
}

.status-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.status-chip {
  font-weight: 500 !important;
  border-radius: 15px !important;
  min-width: 80px;
  height: 30px;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.status-chip:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.status-text {
  font-size: 0.75rem;
  font-weight: 600;
  margin-left: 4px;
}

/* Status Colors */
.status-chip.v-chip--variant-flat.text-success {
  background: #edf7ed !important;
  color: #327e35 !important;
  border: 1px solid rgba(76, 175, 80, 0.2);
}

.status-chip.v-chip--variant-flat.text-warning {
  background: #fff5e6 !important;
  color: #ae5800 !important;
  border: 1px solid rgba(255, 152, 0, 0.2);
}

.status-chip.v-chip--variant-flat.text-grey {
  background: #f5f5f5 !important;
  color: #616161 !important;
  border: 1px solid rgba(158, 158, 158, 0.2);
}

/* Icon styling */
.status-chip .v-icon {
  opacity: 0.8;
}
.personal-info-switch-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 36px;
}

.personal-switch {
  margin: 0 !important;
}

.personal-switch :deep(.v-switch__track) {
  opacity: 0.6;
}

.personal-switch :deep(.v-switch__thumb) {
  transition: all 0.2s ease;
}


.personal-switch :deep(.v-input--error) {
  color: inherit !important;
}

/* Hover effects */
.personal-switch:hover .personal-icon {
  opacity: 1;
  transform: scale(1.05);
}

.download-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.white-svg {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  filter: brightness(0) invert(1);
}

.dialog-header-doc{
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 20px 20px 10px 20px;
  border-bottom: 1px solid #e1e5e9;
  position: relative;
}

.delete-cancel-btn-1 {
  background-color: white !important;
  color: #C30000 !important;
  border: 1px solid #C30000 !important;
  border-radius: 11px !important;
  padding: 10px 24px !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  box-shadow: none !important;
  height: 40px !important;
  min-width: 90px !important;
}
.delete-cancel-btn-1:hover {
  transform: scale(1.1);
}
:deep(.replace-mdi-bfe .mdi-menu-down::before) {
    color: #872612 !important;
    content: "\F035D";
}
.publication-toggle {
  margin: 0 4px;
}

.publication-toggle :deep(.v-switch__track) {
  transform: scale(0.8);
  width: 40px;
  height: 28px;
  border-radius: 999px;
  border: 2px solid transparent;
  background-color: transparent;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.publication-toggle :deep(.v-switch__thumb) {
  width: 20px;
  height: 20px;
  box-shadow: none;
  border: 2px solid transparent;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.publication-toggle--active :deep(.v-switch__track) {
  background-color: #ffffff !important;
  border-color: #d32f2f;
}

.publication-toggle--active :deep(.v-switch__thumb) {
  background-color: #d32f2f !important;
  border-color: #d32f2f;
  transform: translateX(-0.5px);
}

.publication-toggle--inactive :deep(.v-switch__track) {
  background-color: #bdbdbd !important;
  border-color: #bdbdbd;
}

.publication-toggle--inactive :deep(.v-switch__thumb) {
  background-color: #ffffff !important;
  border-color: #bdbdbd;
  width: 30px;
  height: 30px;
}
</style>
